define("shared/components/shared/pre-boarding/auto-trial-start/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "tracked-built-ins", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _trackedBuiltIns, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"tracked-built-ins",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @closable={{false}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}} class="tCH--plan--{{this.planType}}">
  
      <modal.card-header>
        <h3 class="o--modalHeader__title u--m__b__sm">
          {{t (concat "onboarding.trial_start_on_account_sign_up." this.planType ".header")}}
        </h3>
        <p class="u--m__b__0">
          {{t (concat "onboarding.trial_start_on_account_sign_up." this.planType ".desc")}}
        </p>
      </modal.card-header>
  
      <modal.card-body class="u--p__t__0 u--p__b__md">
        <h3 class="o--modalHeader__title tCH--text--highlight u--p__b">
          {{t "plans.choose_your_upgrade.plan.growth"}}
        </h3>
        <div class="u--row u--row--noCollapse tPF--plan__item--growth">
          {{#each this.plan.autoTrialActivationHighlights.keyFeatures as |feature|}}
            <p class="u--col__6 tPF--plan__metaRow u--text__md">
              {{svg-jar "check" class="o--icon tPF--plan__icon"}}
              <span>{{feature}}</span>
            </p>
          {{/each}}
        </div>
        <Shared::Ui::Button
          @onClick={{this.toggleAllFeaturesModal}}
          @variant="unstyled"
          class="u--text--hair o--btn u--p__lr__0"
        >
          {{svg-jar "info" class="o--icon tPF--plan__icon"}}
          {{t "plans.see_all_features"}}
        </Shared::Ui::Button>
  
        <div class="u--flex u--flex__justify--end u--p__t__md">
          <p class="u--text--light u--m__b__0">
            {{t (concat "onboarding.trial_start_on_account_sign_up." this.planType ".note")}}
          </p>
        </div>
      </modal.card-body>
  
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{@closeModal}}
          @text={{t (concat "onboarding.trial_start_on_account_sign_up." this.planType ".get_started")}}
          @variant="primary"
          class="u--float--right"
        />
      </modal.card-footer>
  
    </modal.card>
  </Shared::Modal>
  
  {{#if this.showAllFeaturesModal}}
    <Shared::Upgrade::AllFeaturesModal
      @close={{toggle-action "showAllFeaturesModal" this}}
      @focusTrap={{true}}
      @isMonthly={{true}}
      @plan={{this.plan}}
    />
  {{/if}}
  */
  {
    "id": "s3wflrXd",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@focusTrap\"],[false,true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[16,0,[29,[\"tCH--plan--\",[30,0,[\"planType\"]]]]]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,1,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h3\"],[14,0,\"o--modalHeader__title u--m__b__sm\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[28,[37,2],[\"onboarding.trial_start_on_account_sign_up.\",[30,0,[\"planType\"]],\".header\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[28,[37,2],[\"onboarding.trial_start_on_account_sign_up.\",[30,0,[\"planType\"]],\".desc\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 u--p__b__md\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h3\"],[14,0,\"o--modalHeader__title tCH--text--highlight u--p__b\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"plans.choose_your_upgrade.plan.growth\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--row u--row--noCollapse tPF--plan__item--growth\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"plan\",\"autoTrialActivationHighlights\",\"keyFeatures\"]]],null]],null],null,[[[1,\"          \"],[10,2],[14,0,\"u--col__6 tPF--plan__metaRow u--text__md\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"check\"],[[\"class\"],[\"o--icon tPF--plan__icon\"]]]],[1,\"\\n            \"],[10,1],[12],[1,[30,2]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n      \"],[8,[39,6],[[24,0,\"u--text--hair o--btn u--p__lr__0\"]],[[\"@onClick\",\"@variant\"],[[30,0,[\"toggleAllFeaturesModal\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon tPF--plan__icon\"]]]],[1,\"\\n        \"],[1,[28,[35,1],[\"plans.see_all_features\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[10,0],[14,0,\"u--flex u--flex__justify--end u--p__t__md\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[28,[37,2],[\"onboarding.trial_start_on_account_sign_up.\",[30,0,[\"planType\"]],\".note\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,6],[[24,0,\"u--float--right\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,3],[28,[37,1],[[28,[37,2],[\"onboarding.trial_start_on_account_sign_up.\",[30,0,[\"planType\"]],\".get_started\"],null]],null],\"primary\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"showAllFeaturesModal\"]],[[[1,\"  \"],[8,[39,8],null,[[\"@close\",\"@focusTrap\",\"@isMonthly\",\"@plan\"],[[28,[37,9],[\"showAllFeaturesModal\",[30,0]],null],true,true,[30,0,[\"plan\"]]]],null],[1,\"\\n\"]],[]],null]],[\"modal\",\"feature\",\"@closeModal\"],false,[\"shared/modal\",\"t\",\"concat\",\"each\",\"-track-array\",\"svg-jar\",\"shared/ui/button\",\"if\",\"shared/upgrade/all-features-modal\",\"toggle-action\"]]",
    "moduleName": "shared/components/shared/pre-boarding/auto-trial-start/index.hbs",
    "isStrictMode": false
  });
  let AutoTrialStartComponent = _exports.default = (_class = class AutoTrialStartComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "subscriptions", _descriptor, this);
      _initializerDefineProperty(this, "plans", _descriptor2, this);
      _defineProperty(this, "planType", 'growth');
      _initializerDefineProperty(this, "plan", _descriptor3, this);
      _initializerDefineProperty(this, "showAllFeaturesModal", _descriptor4, this);
      _defineProperty(this, "getPlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.subscriptions.getAllSubscriptionPlans();
          this.plan = this.plans.getPlan(this.planType) || undefined;
        }
      }), null, "getPlan", null));
      this.getPlan.perform();
    }
    toggleAllFeaturesModal() {
      this.showAllFeaturesModal = !this.showAllFeaturesModal;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "plan", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showAllFeaturesModal", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleAllFeaturesModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAllFeaturesModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AutoTrialStartComponent);
});